import pl from './locales/pl.json';
import uk from './locales/uk.json';
import type { Locale } from './enums.js';

/**
 * One source of message bundles for storefront, admin and API error messages. The API
 * needs them because emails and validation errors must arrive in the customer's locale,
 * not the server's.
 */
export type MessageBundle = typeof pl;
export const MESSAGES: Record<Locale, MessageBundle> = { pl, uk: uk as MessageBundle };

/** Dot-path lookup with `{{var}}` interpolation. Falls back to `pl`, never to blank. */
export function translate(
  locale: Locale,
  path: string,
  vars: Record<string, string | number> = {},
): string {
  const bundle = MESSAGES[locale] ?? MESSAGES.pl;
  const raw =
    lookup(bundle, path) ?? lookup(MESSAGES.pl, path) ?? path;
  let value = raw;
  for (const [key, replacement] of Object.entries(vars))
    value = value.split(`{{${key}}}`).join(String(replacement));
  return value;
}

function lookup(bundle: MessageBundle, path: string): string | undefined {
  const found = path.split('.').reduce<unknown>((acc, key) => {
    if (acc && typeof acc === 'object') return (acc as Record<string, unknown>)[key];
    return undefined;
  }, bundle);
  return typeof found === 'string' ? found : undefined;
}
